import TextDisplay from './TextDisplay';
import TextMeta from './TextMeta';
import { TextP1, TextP2, TextP3 } from './TextParagraph';

export { TextDisplay, TextMeta, TextP1, TextP2, TextP3 };
